import * as enumData from "~/config/enum.config";
import appConfig from "~/config/app.config";
import { DictService } from "~/utils/dict.service";
import { endOfDay as DateFnsEndOfDay, startOfDay as DateFnsStartOfDay, format as DateFnsFormat } from "date-fns";
import { LodashService } from "~/utils/lodash.service";
var FilterService = /** @class */ (function () {
    function FilterService() {
    }
    /**
     * 转换枚举数据
     * @param value
     * @param key
     */
    FilterService.enumConvert = function (value, key) {
        // 排除空字典或者空key
        if (!enumData || !key || !enumData[key]) {
            return "";
        }
        var data = enumData[key] instanceof Array
            ? enumData[key]
            : Object.values(enumData[key]);
        var target = data.find(function (x) { return x.value === value; });
        return target ? target.name : "";
    };
    /**
     * 转换字典数据
     * @param 字典code
     */
    FilterService.dictConvert = function (code, key) {
        if (!code || !key) {
            return "";
        }
        return DictService.getDictName(code, key);
    };
    /**
     * 转换字典数据List
     * @param 字典code
     */
    FilterService.dictConvertList = function (code, key) {
        if (!code || !key) {
            return "";
        }
        var name = "";
        var array = code.split(",");
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var a = array_1[_i];
            if (!name) {
                name = DictService.getDictName(a, key);
            }
            else {
                name += "," + DictService.getDictName(a, key);
            }
        }
        return name;
    };
    /**
     * 日期范围转换
     * @param dateRange
     * @param fmt
     */
    FilterService.dateRanageFormat = function (dateRange, fmt) {
        if (fmt === void 0) { fmt = "YYYY-MM-DD HH:mm:ss"; }
        var target = {
            start: "",
            end: ""
        };
        // 检测非法输入
        if (!dateRange || dateRange.length === 0 || !(dateRange instanceof Array)) {
            return target;
        }
        // 获取开始时间
        var tmpDate = DateFnsStartOfDay(dateRange[0]);
        target.start = FilterService.dateFormat(tmpDate, fmt);
        // 获取当前的最后时间点
        tmpDate = DateFnsEndOfDay(dateRange[1]);
        target.end = FilterService.dateFormat(tmpDate, fmt);
        return target;
    };
    /**
     * 日期格式转换（获取当前的最后时间点）
     * @param data
     * @param fmt
     */
    FilterService.dateEndFormat = function (data, fmt) {
        if (fmt === void 0) { fmt = "YYYY-MM-DD HH:mm:ss"; }
        // 获取当前的最后时间点
        var tmpDate = DateFnsEndOfDay(data);
        var endtarget = FilterService.dateFormat(tmpDate, fmt);
        return endtarget;
    };
    /**
     * 日期格式化
     * @param date
     */
    FilterService.dateMonthFormat = function (date, fmt) {
        if (fmt === void 0) { fmt = "YYYY-MM"; }
        // 空数据处理
        if (date === null || date === undefined || date === "") {
            return "";
        }
        return DateFnsFormat(date, fmt);
    };
    /**
     * 日期时间格式化
     * @param date
     * @param fmt
     */
    FilterService.dateTimeFormat = function (date, fmt) {
        if (fmt === void 0) { fmt = "YYYY-MM-DD HH:mm:ss"; }
        return FilterService.dateFormat(date, fmt);
    };
    /**
     * 日期格式化
     * @param date
     */
    FilterService.dateFormat = function (date, fmt) {
        if (fmt === void 0) { fmt = "YYYY-MM-DD"; }
        // 空数据处理
        if (date === null || date === undefined || date === "") {
            return "";
        }
        return DateFnsFormat(date, fmt);
    };
    /**
     * 千分位转换
     * @param value
     */
    FilterService.toThousands = function (value, fixed) {
        if (fixed === void 0) { fixed = 2; }
        var num = "";
        if (value === null || value === "") {
            num = value;
        }
        else {
            num = Number(value).toFixed(fixed);
            if (isNaN(num) || num === "" || num === undefined || num === null) {
                return "";
            }
            num = num + "";
            if (/^.*\..*$/.test(num)) {
                var pointIndex = num.lastIndexOf(".");
                var intPart = num.substring(0, pointIndex);
                var pointPart = num.substring(pointIndex + 1, num.length);
                intPart = intPart + "";
                var re = /(-?\d+)(\d{3})/;
                while (re.test(intPart)) {
                    intPart = intPart.replace(re, "$1,$2");
                }
                num = intPart + "." + pointPart;
            }
            else {
                num = num + "";
                var re = /(-?\d+)(\d{3})/;
                while (re.test(num)) {
                    num = num.replace(re, "$1,$2");
                }
            }
        }
        return num;
    };
    /**
     * 手机号脱敏显示转换器
     */
    FilterService.encryptPhone = function (value) {
        if (!appConfig.encryptSwitch)
            return "";
        if (!value || value === "")
            return "";
        if (value.length < 4)
            return value;
        return value.substr(0, 3) + "****" + value.substr(-4);
    };
    /**
     * 身份证脱敏显示转换器
     */
    FilterService.encryptIDCardFour = function (value) {
        if (!appConfig.encryptSwitch)
            return "";
        if (!value || value === "")
            return "";
        // return value.substr(0, 3).padEnd(value.length - 4, '*') + value.substr(-4)
        if (value.length < 4)
            return value;
        return value.substr(0, 3) + "****" + value.substr(-4);
    };
    /**
     * 长度过长省略显示
     */
    FilterService.ellipsis = function (value, length) {
        if (!value) {
            return "";
        }
        var data = String(value).trim();
        if (data.length <= length) {
            return data;
        }
        else {
            return data.substr(0, length) + "...";
        }
    };
    /**
     * 小数转换为百分比
     * @param point 要转换的小数
     */
    FilterService.toPercent = function (point) {
        var str = "--";
        if (point !== undefined) {
            point *= 100;
            str = (point > 0 ? point.toFixed(2) : 0) + "%";
        }
        return str;
    };
    /**
     * 字符串截取
     * @param str 要截取的字符串
     * @param subIndex 截取长度,默认6位
     */
    FilterService.subString = function (str, subIndex) {
        if (subIndex === void 0) { subIndex = 6; }
        if (!str) {
            return "";
        }
        return str.length > subIndex ? str.substring(0, subIndex) + "..." : str;
    };
    /**
     * 对字符串进行格式化
     * @param str 要格式化的字符串
     * @param length 每行字符长度
     * @param appendStr 要插入的字符串
     */
    FilterService.strSplit = function (str, length, appendStr) {
        if (length === void 0) { length = 4; }
        if (appendStr === void 0) { appendStr = "-"; }
        if (!str)
            return "";
        var r = new RegExp(".{" + length + "}", "g");
        var s = new RegExp(appendStr + "$", "g");
        return str.replace(r, function ($0) { return $0 + appendStr; }).replace(s, "");
    };
    /**
     * 格式化显示金额追加百分比符号
     * @param value 要格式化的金额
     */
    FilterService.percentFormat = function (value) {
        if (!value && value !== 0)
            return null;
        var result = LodashService.round(value, 4);
        return result + "%";
    };
    /**
     *
     * @param value 要格式化的金额字符串
     * @param roundPre 精度 默认为2
     */
    FilterService.moneyFormat = function (value, roundPre) {
        if (roundPre === void 0) { roundPre = 2; }
        var result = LodashService.round(value, roundPre);
        return ("" + result).replace(/^\d+/g, function (m) {
            return m.replace(/(?=(?!^)(\d{3})+$)/g, ",");
        });
    };
    /**
     *
     * @param value 要格式化的金额或字符串
     * @param d 要保留的小数位数
     */
    FilterService.decimalToPrecent = function (value, d) {
        if (d === void 0) { d = 2; }
        if (!value) {
            return "0";
        }
        var f = 0;
        var result = "";
        f = parseFloat(value) || f;
        result = LodashService.round(f * 100, d);
        return FilterService.percentFormat(result);
    };
    /**
     * 格式化万元
     * @param val
     */
    FilterService.toTenThousands = function (val) {
        if (!val)
            return "";
        return FilterService.toThousands(val / 10000);
    };
    /**
     * 数组去重
     * @param val
     */
    FilterService.arrayUniq = function (val) {
        return Array.from(new Set(val));
    };
    /**
     * 执行频次计算
     */
    FilterService.getAllDate = function (start, end, days, timeType) {
        var dateArr = [];
        var startDate = new Date(start);
        startDate = startDate.valueOf();
        var endDate = new Date(end);
        endDate = endDate.valueOf();
        var stamp = startDate;
        // stamp=stamp.valueOf()
        var ww = timeType === "DAY"
            ? Number(days) * 24 * 60 * 60 * 1000
            : Number(days) * 60 * 60 * 1000;
        var i = 1;
        for (stamp = startDate; stamp <= endDate;) {
            var nd1 = new Date(stamp);
            var y1 = nd1.getFullYear();
            var m1 = nd1.getMonth() + 1;
            var d1 = nd1.getDate();
            var e1 = nd1.getHours();
            var f1 = nd1.getMinutes();
            var g1 = nd1.getSeconds();
            if (m1 <= 9)
                m1 = "0" + m1;
            if (d1 <= 9)
                d1 = "0" + d1;
            if (e1 <= 9)
                e1 = "0" + e1;
            if (f1 <= 9)
                f1 = "0" + f1;
            if (g1 <= 9)
                g1 = "0" + g1;
            var stampDate = y1 + "-" + m1 + "-" + d1 + " " + e1 + ":" + f1 + ":" + g1;
            dateArr.push(stampDate);
            stamp = stamp + ww;
            i++;
        }
        return dateArr;
    };
    return FilterService;
}());
export { FilterService };
